import React from 'react';
import { ArrowRight as ArrowRightIcon, CheckCircle as CheckCircleIcon } from '@phosphor-icons/react';
import { Section, SectionTitle, Lead } from '../Section';
import { PhoneFrame } from '../PhoneFrame';
import { clinicians, caseImage, teaserScreens } from '../../data/proposal';
const clinician = clinicians[0];
function ScreenOne() {
  return <div className="relative h-full w-full" data-id="element-304" data-mp="26u989iq9tnsg">
      <img src={clinician.portrait} alt={`Portrait of ${clinician.name}`} className="h-full w-full object-cover object-top" data-id="element-305" data-mp="21vy49omnq7i5" />
      <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#01332b] via-[#01332b]/85 to-transparent p-4 pt-16" data-id="element-306" data-mp="1x2mrl6v5ywib">
        <p className="font-body text-[9px] uppercase tracking-[0.18em] text-secondary/80" data-id="element-307" data-mp="1n6tijxgnll5a">
          {clinician.credentials}
        </p>
        <p className="mt-1 font-heading text-sm text-white" data-id="element-308" data-mp="1j3wxm03n5cy6">{clinician.name}</p>
        <p className="mt-2 font-heading text-[13px] leading-snug text-primary" data-id="element-309" data-mp="1e5ll1hlyooc9">
          {clinician.hook}
        </p>
      </div>
    </div>;
}
function ScreenTwo() {
  return <div className="flex h-full w-full flex-col" data-id="element-310" data-mp="1tkrv660w5bn7">
      <img src={caseImage} alt="Clinical case photograph" className="h-1/2 w-full object-cover" data-id="element-311" data-mp="1tmmhnort9bte" />
      <div className="flex-1 p-4" data-id="element-312" data-mp="1fv7x3di992k8">
        <p className="font-body text-[9px] uppercase tracking-[0.18em] text-secondary/70" data-id="element-313" data-mp="1frtx2bx2d5fy">
          The case
        </p>
        <p className="mt-2 font-body text-[11px] leading-relaxed text-white/80" data-id="element-314" data-mp="27kb3aytpcmzi">
          Extensive root caries. Access, moisture control and adaptation all limited the
          restorative options.
        </p>
      </div>
    </div>;
}
function ScreenThree() {
  const options = ['Access', 'Moisture control', 'Adaptation', 'Patient time'];
  return <div className="flex h-full w-full flex-col p-4" data-id="element-315" data-mp="23hehkz8v8arc">
      <p className="font-heading text-[13px] leading-snug text-white" data-id="element-316" data-mp="n4pvkgx6j98x">{clinician.interaction}</p>
      <ul className="mt-4 space-y-2" data-id="element-317" data-mp="s4c9ksku0tis">
        {options.map((option, i) => <li key={option} className={`flex items-center justify-between rounded-lg border px-3 py-2 font-body text-[10px] ${i === 1 ? 'border-primary bg-primary/15 text-white' : 'border-white/15 text-white/65'}`} data-id="element-318" data-mp="2tsynm4lfnb62" data-mpi={i}>
            {option}
            {i === 1 ? <CheckCircleIcon size={12} weight="fill" className="text-primary" aria-hidden="true" data-id="element-319" data-mp="2g1l5mv36ald5" /> : null}
          </li>)}
      </ul>
      <p className="mt-auto font-body text-[9px] uppercase tracking-[0.16em] text-secondary/60" data-id="element-320" data-mp="263481f9qb8i4">
        62% of HCPs agree with you
      </p>
    </div>;
}
function ScreenFour() {
  return <div className="flex h-full w-full flex-col justify-center gap-3 p-4" data-id="element-321" data-mp="1x3h7evotq6q4">
      <p className="font-body text-[9px] uppercase tracking-[0.18em] text-secondary/70" data-id="element-322" data-mp="1x5br66oczssm">Reveal</p>
      <p className="font-heading text-[15px] leading-snug text-primary" data-id="element-323" data-mp="3vg92zmkxg9cs">{clinician.tease}</p>
      <p className="font-body text-[11px] leading-relaxed text-white/70" data-id="element-324" data-mp="3rf5rfc9wwzhd">
        He reached for a flowable first — and the reason changed the whole sequence.
      </p>
      <p className="font-body text-[10px] italic text-white/40" data-id="element-325" data-mp="1i6r731t00hrf">The rest is in the full case.</p>
    </div>;
}
function ScreenFive() {
  return <div className="flex h-full w-full flex-col justify-end gap-3 p-4" data-id="element-326" data-mp="1r0e0wmdnbaxz">
      <img src={clinician.portrait} alt="" className="h-24 w-24 rounded-full object-cover" data-id="element-327" data-mp="1r2qdsl4jqv46" />
      <p className="font-heading text-[15px] leading-snug text-white" data-id="element-328" data-mp="z9g5vbnt3e9c">
        See the complete clinical case
      </p>
      <span className="inline-flex items-center justify-center gap-2 rounded-full bg-primary px-3 py-2 font-body text-[10px] font-semibold uppercase tracking-[0.14em] text-[#01332b]" data-id="element-329" data-mp="13as2i153kzr1">
        Watch now
        <ArrowRightIcon size={11} weight="bold" aria-hidden="true" data-id="element-330" data-mp="2eqzux9qteuoz" />
      </span>
      <p className="font-body text-[9px] text-white/40" data-id="element-331" data-mp="2jp1fjz3w322k">Filtek Clinical Cases</p>
    </div>;
}
const screenRenderers = [ScreenOne, ScreenTwo, ScreenThree, ScreenFour, ScreenFive];
export function TeaserSection() {
  return <Section id="teaser" index="05" label="The teaser" data-id="element-332" data-mp="2da2v3tanofko">
      <div className="grid gap-5 lg:grid-cols-[1fr_0.8fr] lg:items-end lg:gap-14" data-id="element-333" data-mp="2r8u6v921pp5n">
        <SectionTitle data-id="element-334" data-mp="2r6pu01m65ft8">
          Short enough to interrupt.
          <br data-id="element-335" data-mp="2n660r94puwcd" />
          Strong enough to continue.
        </SectionTitle>
        <Lead data-id="element-336" data-mp="316gnbzyztorq">
          Five screens. Under a minute. The HCP leaves with a question they want answered — not a
          summary that replaces the case.
        </Lead>
      </div>

      <div className="mt-8 grid grid-cols-2 gap-6 sm:grid-cols-3 lg:grid-cols-5 lg:gap-4" data-id="element-337" data-mp="3awtgggkviq9h">
        {teaserScreens.map((screen, i) => {
        const Screen = screenRenderers[i];
        return <div key={screen.step} data-id="element-338" data-mp="3jx861s4veris" data-mpi={i}>
              <PhoneFrame data-id="element-339" data-mp="3jy9io11jbm2m">
                <Screen data-id="element-340" data-mp="3jxrgyow3sfnb" />
              </PhoneFrame>
              <div className="mt-3 text-center" data-id="element-341" data-mp="3ez6cuedqdbtl">
                <p className="font-body text-[11px] uppercase tracking-[0.2em] text-primary" data-id="element-342" data-mp="3ewbssnympt0p">
                  {screen.step}
                </p>
                <p className="mt-0.5 font-heading text-base text-white" data-id="element-343" data-mp="7e5gkxx2zy3y">{screen.title}</p>
                <p className="mx-auto mt-1.5 max-w-[200px] font-body text-xs leading-relaxed text-white/50" data-id="element-344" data-mp="3pk1o57ez4dgp">
                  {screen.note}
                </p>
              </div>
            </div>;
      })}
      </div>

      <div className="mt-8 flex flex-wrap items-baseline gap-x-6 gap-y-2 rounded-xl border border-primary/30 bg-primary/[0.07] px-6 py-4" data-id="element-345" data-mp="3fsx8s6ldyqlc">
        <p className="font-heading text-xl text-primary lg:text-2xl" data-id="element-346" data-mp="3km8jwjx8dtj2">
          Tease the case. Don’t summarise it.
        </p>
        <p className="max-w-xl font-body text-base text-white/65" data-id="element-347" data-mp="3au2sbbaw5e4e">
          If the HCP gets the entire answer in the Teaser, we’ve removed the reason to continue.
        </p>
      </div>
    </Section>;
}